import PropTypes from 'prop-types';
import React, { useContext } from 'react';

import ModelContext from 'features/sort/modelContext';
import isMappedTo from 'features/sort/isMappedTo';

import SortFilterAppliedFilterClearButton from './SortFilterAppliedFilterClearButton';

import './SortFilterAppliedFilter.scss';

const SortFilterAppliedFilter = ({ name, value, stepbackLink }) => {

	const { setDisplayTypeId } = useContext(ModelContext);
	const isLeftNav = isMappedTo.set.interfaceType.leftNav(setDisplayTypeId);

	if (isLeftNav) {

		return (
			<div className="SortFilterAppliedFilter__filterValue">
				<span>
					{value}
				</span>
				{stepbackLink ? (
					<SortFilterAppliedFilterClearButton
						attributeName={name}
						attributeValue={value}
						stepbackLink={stepbackLink}
					>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15" fill="none" stroke="#000000" strokeLinecap="round" strokeLinejoin="round" height="20" width="20" aria-hidden="true">
							<circle cx="7.5" cy="7.5" r="6.25" strokeWidth="1" />
							<path d="M9.375 5.625 L5.625 9.375" strokeWidth="1" />
							<path d="M5.625 5.625 L9.375 9.375" strokeWidth="1" />
						</svg>
					</SortFilterAppliedFilterClearButton>
				) : null}

			</div>
		);

	}

	return (stepbackLink ? (
		<SortFilterAppliedFilterClearButton attributeName={name} attributeValue={value} stepbackLink={stepbackLink}>
			<span className="lpIcon-close01" />
			<span>
				{value}
			</span>
		</SortFilterAppliedFilterClearButton>
	) : (
		<div className="SortFilterAppliedFilter__filterValue">
			{value}
		</div>
	));

};

SortFilterAppliedFilter.propTypes = {
	name: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
	stepbackLink: PropTypes.string
};

export default SortFilterAppliedFilter;
